import { App } from 'vue'
import 'element-plus/lib/theme-chalk/base.css'
import {
  ElButton,
  ElCheckbox,
  ElForm,
  ElFormItem,
  ElInput,
  ElLink,
  ElRadio,
  ElTabPane,
  ElTabs,
  ElDatePicker,
  ElTooltip,
  ElCarousel,
  ElCarouselItem,
} from 'element-plus'

const components = [
  ElButton,
  ElForm,
  ElFormItem,
  ElInput,
  ElRadio,
  ElTabs,
  ElTabPane,
  ElCheckbox,
  ElLink,
  ElDatePicker,
  ElTooltip,
  ElCarousel,
  ElCarouselItem,
]

export default function (app: App): void {
  for (const component of components) {
    app.component(component.name, component)
  }
}
